import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { GroupTablePage } from "./GroupTablePage";
import { RegisteredUserTablePage } from "./RegisteredUserTablePage";
import { SchoolMetricsLoadingPage } from "./SchoolMetrics";
import { StudentMetricsLoadingPage } from "./StudentMetricsPage";
// import { MetricsPage } from "./MetricsPage";
// import { StudentMetricsLoadingPage } from "./ParentMetricsPage";
import { StudentTablePage } from "./StudentTablePage";
import { TeacherMetricsLoadingPage } from "./TeacherMetricsPage";

export const MetricsSwitch = (): JSX.Element => (
	<Switch>
		<Route exact path={[routes._.metrics.path]}>
			{/* <MetricsPage /> */}
			<GroupTablePage />
		</Route>

		<Route exact path={[routes._.metrics._.Groups.path]}>
			<GroupTablePage />
		</Route>

		<Route exact path={[routes._.metrics._.RegisteredUsers.path]}>
			<RegisteredUserTablePage />
		</Route>

		<Route exact path={[routes._.metrics._.School.path]}>
			<SchoolMetricsLoadingPage />
		</Route>

		<Route
			exact
			path={[
				routes._.metrics._.Students.path,
				routes._.metrics._.Groups._.viewGroup.path,
			]}
		>
			<StudentTablePage />
		</Route>

		{/* <Route exact path={routes._.result._.viewResult.path}> */}
		<Route exact path={routes._.metrics._.viewMetrics.path}>
			<StudentMetricsLoadingPage />
		</Route>

		{/* <Route exact path={routes._.metrics._.Groups._.viewGroup.path}> */}
		<Route exact path={routes._.metrics._.viewGroupMetrics.path}>
			<TeacherMetricsLoadingPage />
		</Route>
	</Switch>
);

// export const StudentMetricsSwitch = (): JSX.Element => {
// 	return (
// 		<Switch>
// 			<Route exact path={[routes._.result._.viewResult.path]}>
// 				<ParentResultPage />
// 			</Route>
// 			<Route exact path={[routes._.result.path]}>
// 				<StudentResultLoadingPage />
// 			</Route>
// 		</Switch>
// 	);
// };
